import { render, staticRenderFns } from "./ClientFolderList.vue?vue&type=template&id=00705601&"
import script from "./ClientFolderList.vue?vue&type=script&lang=js&"
export * from "./ClientFolderList.vue?vue&type=script&lang=js&"
import style0 from "./ClientFolderList.vue?vue&type=style&index=0&id=00705601&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports